<section class="deadline-table-b" id="deadline-table" *ngIf="showDeadline" #containerDeadline>

  <div class="content-loader" *ngIf="loadingDeadline || deadlines.length === 0;else showDeadlineTable">
    <app-loading-spinner></app-loading-spinner>
  </div>
  <ng-template #showDeadlineTable>

    <div class="container-table mt-20" #table>
      <ng-container *ngFor="let deadline of deadlines; index as i">
        <div class="container-column"
          [ngClass]="{'reduce-margin': (deadline.title === 'afin' || deadline.title === 'rr') && i === 0}"
          *ngIf="!deadline.hide">
          <div class="title-column"
            [ngClass]="{'hidde-title': (deadline.title === 'afin' || deadline.title === 'rr') && i === 1}">
            <span class="title" [ngClass]="{'credit': deadline.title === 'Crédito tradicional'}">
              {{(deadline.title === 'afin' || deadline.title === 'rr') ?  i === 0 ? 'Rent2Buy' : '' : deadline.title}}
            </span>


          </div>
          <div class="container-column_cards scroll-none"
            [ngClass]="{'second-row-afin': (deadline.title === 'afin' || deadline.title === 'rr') && i === 1}">
            <div class="card-term card-{{indexData}}"
              [ngClass]="{'comparative-card': i === 1, 'selected-card': checkSelectCard(deadline.title, item.type) }"
              *ngFor="let item of deadline.data; index as indexData"
              (click)="selectDeadline(deadline.title, item.values, true)">
              <div class="row-top">
                <p class="term">{{item.type}} meses</p>
                <h1 class="pay-month">{{item.values.monthlyPayment | currency}} <span class="text">pago mensual</span>
                </h1>
              </div>
              <div class="pay-init">{{item.values.initialPayment | currency}} <span class="value-text">Pago inicial</span></div>
              <div class="purchaseValue" *ngIf="item?.values?.purchaseValue">{{item.values.purchaseValue | currency}}
                <span class="value-text">valor de compra</span>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </ng-template>

</section>